import type { FunctionComponent } from 'react'
import { createContext, useContext } from 'react'

type PropertyTracking = {
  property_id: number
  title: string | undefined | null
  property_address: string | undefined | null
}

type ProjectTracking = {
  projectId: number
}

type PropertyReservationTracking = {
  propertyId: string
  reservationTool: boolean
}

type ReservationIndexTracking = {
  reservationTool: boolean
}

type StaticPageTracking = {
  slug: string
  staticPageId: string | undefined
  propertyId: number | undefined
}

type LexiconTracking = {
  slug: string | undefined | null
  lexiconLetter: string | undefined | null
  contentfulId: string | undefined
  lexiconArticleId: number
}

type NewsArticleTracking = {
  newsType: string | undefined | null
  slug: string | undefined | null
  articleId: number
}

export type IAdditionalTrackingInfoContext =
  | PropertyTracking
  | ProjectTracking
  | PropertyReservationTracking
  | ReservationIndexTracking
  | StaticPageTracking
  | LexiconTracking
  | NewsArticleTracking

const AdditionalTrackingInfoContext =
  createContext<IAdditionalTrackingInfoContext | null>(null)

export const AdditionalTrackingInfoContextProvider: FunctionComponent<
  React.PropsWithChildren<{
    context: IAdditionalTrackingInfoContext
  }>
> = ({ children, context }) => {
  return (
    <AdditionalTrackingInfoContext.Provider value={context}>
      {children}
    </AdditionalTrackingInfoContext.Provider>
  )
}

export const useAdditionalTrackingInfoContext = () => {
  return useContext(AdditionalTrackingInfoContext)
}
